

export const carrieReviewerReviewHinge = {
  _id: 'carrieReviewerReviewHingeId',
  email: 'carrie@email.com',
  profileReviewId: 'carrieProfileReviewHingeId',
  reviewerProfileId: 'carrieReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Carrie! This will really help me!',
  profileReviewedFirstName: 'Samantha',
}

export const mirandaReviewerReviewBumble = {
  _id: 'mirandaReviewerReviewBumbleId',
  email: 'miranda@email.com',
  profileReviewId: 'mirandaProfileReviewBumbleId',
  reviewerProfileId: 'mirandaReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Miranda! This will really help me!',
  profileReviewedFirstName: 'Samantha',
}

export const charlotteReviewerReviewTinder = {
  _id: 'charlotteReviewerReviewTinderId',
  email: 'charlotte@email.com',
  profileReviewId: 'charlotteProfileReviewTinderId',
  reviewerProfileId: 'charlotteReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Charlotte! This will really help me!',
  profileReviewedFirstName: 'Samantha',
}